import { createContext } from 'react';
import { BalanceTheme } from '@balance-web/theme';
import { ResponsiveProp } from '@balance-web/core';

export type PageBlockContextShape = {
  size?: ResponsiveProp<keyof BalanceTheme['breakpoints']>;
};
export const PageBlockContext = createContext<PageBlockContextShape>({
  size: 'large',
});
